// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Calendar } from 'antd';
import 'antd/dist/antd.css';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

// Components
import Popup from 'reactjs-popup';

// My customs hooks
import useModalDashboard from '../../hooks/useModalDashboard';

// Images
import closeIcon from '../../../sass/images/icons/close.svg';

function modalScheduling({ isBlocked, close }) {
  const {
    disabledDate,
    disabledButton,
    changeDisabledButton,
    changeNextModal,
    nextModal,
    onPanelChange,
    closeModal,
    changeReturnModal,
    month,
  } = useModalDashboard();
  const { t } = useTranslation(['dahsboard', 'alert', 'routers']);

  const year = moment().format('YYYY');

  return (
    <>
      <Popup open={isBlocked}>
        <div className="modal-design company-design" id="modal-design" />
        <div className="modal-left-company">
          <button type="button" className="close" onClick={close}>
            <img className="modal-image" src={closeIcon} alt={t('alt:close')} />
          </button>
          {!nextModal ? (
            <>
              <div className="modal-content-dashboard">
                <h3 align="center"> {t('tittle_modal-calendar')}</h3>
                <div className="modal-form">
                  <div className="modal-img-box">
                    <p>{t('tittle_modal')}</p>
                  </div>
                  <div className="modal-description">
                    <div className="header-calendar">
                      {month} {year}
                    </div>
                    <Calendar
                      fullscreen={false}
                      disabledDate={disabledDate}
                      onChange={() => changeDisabledButton()}
                      onSelect={onPanelChange}
                    />
                  </div>
                  <div className="modal-action">
                    <button
                      onClick={() => changeNextModal()}
                      disabled={!disabledButton}
                      type="button"
                      className={`btn btn-primary ${!disabledButton ? 'disabled' : 'disabled-off'}`}
                    >
                      {t('button-calendar')}
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="modal-content-dashboard">
                <div className="modal-form">
                  <div className="modal-img-box next">
                    <h3 className="title-calendar"> {t('tittle_modal-2')} </h3>
                  </div>
                  <div className="modal-description-2">
                    <p className="descriptionModal">{t('tittle_modal-calendar-2')}</p>
                  </div>
                  <div className="row modal-action">
                    <div className="col">
                      <button
                        onClick={() => {
                          close();
                          changeReturnModal();
                        }}
                        type="button"
                        className="btn btn-primary disabledButton"
                      >
                        {t('button-calendar-1')}
                      </button>
                    </div>
                    <div className="col">
                      <button
                        onClick={() => closeModal(t('routers:JobRequests'))}
                        type="button"
                        className="btn btn-primary disabledButton-off"
                      >
                        {t('button-calendar-2')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </Popup>
    </>
  );
}

modalScheduling.propTypes = {
  close: PropTypes.func.isRequired,
  isBlocked: PropTypes.bool.isRequired,
};

export default modalScheduling;
